var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{style:(_vm.iframe.style),attrs:{"src":_vm.iframe.src,"height":_vm.iframe.style.height,"width":_vm.iframe.style.width,"frameborder":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }